var NavbarHorizontalStyle1Module = /** @class */ (function () {
    function NavbarHorizontalStyle1Module() {
    }
    return NavbarHorizontalStyle1Module;
}());
export { NavbarHorizontalStyle1Module };
